(function (Drupal, $, once) {
  Drupal.behaviors.otherIngredientSlider = {
    attach: function (context) {
      once('otherIngredientSlider', '#other-ingredient-slider-container', context).forEach(function (element) {
        let slider = null;
        const breakpoint = 1024;

        function initOrDestroy() {
          const windowWidth = window.innerWidth;

          if (windowWidth < breakpoint) {
            if (!slider) {
              slider = new Splide(element, {
                type: 'loop',
                perPage: 4,
                perMove: 1,
                gap: '20px',
                draggable: true,
                arrows: false,
                pagination: true,
                breakpoints: {
                  1024: {
                    perPage: 4,
                    perMove: 1,
                  },
                  768: {
                    perPage: 3,
                    perMove: 1,
                  },
                  680: {
                    perPage: 2,
                    perMove: 1,
                  }
                }
              });

              slider.mount();
            } else {
              slider.refresh();
            }
          } else {
            if (slider) {
              slider.destroy(true);
              slider = null;
            }
          }
        }

        // init on load
        initOrDestroy();

        // re-check on resize
        window.addEventListener('resize', initOrDestroy);
      });
    }
  };
})(Drupal, jQuery, once);
